import { createFileRoute } from "@tanstack/react-router";
import { SurfacePage } from "@/content-site/components/surface-page";
import { loadContentPage, contentHead } from "@/content-site/lib/page";
export const Route = createFileRoute("/_content/audience/")({
  loader: () => loadContentPage(["audience"]),
  head: ({ loaderData }) => contentHead(loaderData),
  component: Page,
});
function Page() {
  return <SurfacePage data={Route.useLoaderData()} />;
}
